var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImessageColor = function SvgImessageColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#imessage-color_svg__a)",
    d: "M2.5 14.5c0-4.2 0-6.3.817-7.905a7.5 7.5 0 0 1 3.278-3.278C8.2 2.5 10.3 2.5 14.5 2.5h11c4.2 0 6.3 0 7.905.817a7.5 7.5 0 0 1 3.277 3.278C37.5 8.2 37.5 10.3 37.5 14.5v11c0 4.2 0 6.3-.818 7.905a7.5 7.5 0 0 1-3.277 3.277C31.8 37.5 29.7 37.5 25.5 37.5h-11c-4.2 0-6.3 0-7.905-.818a7.5 7.5 0 0 1-3.278-3.277C2.5 31.8 2.5 29.7 2.5 25.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 28.75c6.213 0 11.25-4.197 11.25-9.375S26.213 10 20 10 8.75 14.197 8.75 19.375c0 3.282 2.024 6.17 5.088 7.845-.103.833-.411 1.946-1.338 2.78 1.753-.316 3.151-.95 4.196-1.66 1.045.266 2.154.41 3.304.41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "imessage-color_svg__a",
    x1: 20,
    x2: 20,
    y1: 2.5,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AF575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13BD2C"
  })))));
};
export default SvgImessageColor;